import { I18n } from "@assets/strings";
import React from "react";
import { Link } from "react-router";
import styled from "styled-components";
import { useOrganizationAlias } from "@domain/currentProfile/hooks";
import { ImageVersions } from "@domain/media/dtos";
import { Organization } from "@domain/organization/organization";
import { getBanner } from "@utils/banner";
import { useIsMobile } from "@utils/hooks";
import { BackgroundImage } from "@ui/components/backgroundImage";
import { row, stack } from "@ui/components/layout";
import { OrganizationMenu } from "@ui/components/organization/organizationMenu";
import { FollowButton } from "@ui/components/profile/followButton";
import { ProfilePicture } from "@ui/components/profile/profilePicture";
import { mobile } from "@ui/styles/utils";
import { MobileOrganizationHeader } from "./mobileOrganizationHeader";
import { OrganizationData } from "./organizationData";
interface OrganizationHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
	organization: Organization;
}
export const OrganizationHeader: React.FC<OrganizationHeaderProps> = ({ organization, ...htmlProps }) => {
	const { id, avatar, banner, primaryName, type, subType, description } = organization;
	const isMobile = useIsMobile();
	const organizationAlias = useOrganizationAlias();

	if (isMobile) {
		return <MobileOrganizationHeader organization={organization} {...htmlProps} />;
	}
	// const openCorpProfilePicture = (): void => {
	// 	if (avatar) {
	// 		createModal((close) => <CropProfilePicture imageProfile={avatar} close={close} />);
	// 	}
	// };
	return (
		<Relative {...htmlProps}>
			<Container backdrop image={banner} defaultUrl={!banner ? getBanner(id) : undefined} size={ImageVersions.BANNER}>
				<Content>
					<Link to="#">
						<ProfilePicture
							// onClick={openCorpProfilePicture}
							alt={I18n.t("seo.profile.picture", { name: primaryName })}
							shadowed
							picture={avatar}
							size="XL"
							fallbackType={type}
						/>
					</Link>
					<Infos>
						<Name>{primaryName}</Name>
						<OrganizationType>{I18n.t(`organization.type.${subType}`)}</OrganizationType>
						<div>{description}</div>
						<Row hasOffset={!!organizationAlias}>
							{!organizationAlias && <FollowButton isOrg isBig profile={organization} />}
							<OrganizationData organization={organization} />
						</Row>
					</Infos>
				</Content>
			</Container>
			<Menu blur organization={organization} />
		</Relative>
	);
};

const Relative = styled.div`
	position: relative;
`;

const Container = styled(BackgroundImage)`
	border-radius: 13px;
	overflow: hidden;
`;

const Content = styled.div`
	${row("M", "flex-start")};
	padding: 60px;
	@media ${mobile} {
		padding: 20px;
	}
`;

const Infos = styled.div`
	${stack("S")}
	color: ${({ theme }) => theme.colors.white};

	> button {
		margin-top: 20px;
	}
`;

const Name = styled.div`
	${({ theme }) => theme.textStyles.title};
	color: ${({ theme }) => theme.colors.white};
`;

const OrganizationType = styled.div`
	${({ theme }) => theme.textStyles.label};
	color: ${({ theme }) => theme.colors.white};
`;

const Row = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "hasOffset",
})<{ hasOffset: boolean }>`
	${row(14, "flex-start", "center")};
	padding-bottom: ${({ hasOffset }) => (hasOffset ? 17 : 0)}px;
`;

const Menu = styled(OrganizationMenu)`
	position: absolute;
	right: 10px;
	top: 10px;
`;
